import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import "./PageABMs.css";

import Routes_gral from "../../utils/Routes_gral";

//Context
import authContext from "../../context/authentication/authContex";

//Permisos
import { VER_USUARIOS, VER_GRUPOS } from "../../utils/permisos";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faUsersBetweenLines,
  faUsers,
  faCartShopping,
  faBox,
  faSitemap,
} from "@fortawesome/free-solid-svg-icons";

const PageABMs = () => {
  const navigate = useNavigate();

  const aContext = useContext(authContext);
  const { usuario } = aContext;

  const navigateTo = (abm) => {
    navigate(abm);
  };

  return (
    <div className="pageABMsView">
      <div className="multipleOptionsDiv">
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.provider)}>
            <FontAwesomeIcon icon={faCartShopping} className="iconAbm" />
            <label className="labelOptionABM">Proveedores</label>
          </button>
        </div>
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.product)}>
            <FontAwesomeIcon icon={faBox} className="iconAbm" />
            <label className="labelOptionABM">Productos</label>
          </button>
        </div>
        <div className="optionABMDiv">
          <button onClick={() => navigateTo(Routes_gral.distribuciones)}>
            <FontAwesomeIcon icon={faSitemap} className="iconAbm" />
            <label className="labelOptionABM">Distribuciones</label>
          </button>
        </div>
        {usuario.userType.some(item => VER_USUARIOS.includes(item.typeName)) && (
          <div className="optionABMDiv">
            <button onClick={() => navigateTo(Routes_gral.user)}>
              <FontAwesomeIcon icon={faUsers} className="iconAbm" />
              <label className="labelOptionABM">Usuarios</label>
            </button>
          </div>
        )}
        {usuario.userType.some(item => VER_GRUPOS.includes(item.typeName)) && (
          <div className="optionABMDiv">
            <button onClick={() => navigateTo(Routes_gral.group)}>
              <FontAwesomeIcon icon={faUsersBetweenLines} className="iconAbm" />
              <label className="labelOptionABM">Grupos</label>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageABMs;
